import ProviderPatients from './ProviderPatients';

export default ProviderPatients;
